import * as React from 'react';
import {
    ActionPointInfo,
    Controller, IActionPointInfo,
    MainMenu,
    Menu,
    Toolbar,
} from '@tencent/workbench';
import { TailorPicWhFeature } from './tailor-pic-wh-feature';
import {
    config, MENU_CONFIGS, TOOLBAR_ITEMS,
} from './config';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { MenuKey, PREFIX } from '@framework/workbench/schema/menu-schema/common';
import { wrapIdForBig, wrapIdForText } from '@src/framework/workbench/util/wrap-id-util';

@Controller({
    menuItems: MENU_CONFIGS,
    toolbarItems: TOOLBAR_ITEMS,

})
export class TailorPicWhController {
    menuDom;
    constructor(private readonly feature: TailorPicWhFeature) {
    }

    @Toolbar(wrapIdForBig(config.id), 'dropdownContent')
    public getPcBtnDropdownContent() {
        return <MainMenu align="left" name={config.id} mode="menu"/>;
    }

    @Toolbar(wrapIdForBig(config.id), 'onDropdownVisibleChange')
    public onDropdownVisibleChange(visible: boolean) {
        this.feature.updateDropdownVisible(visible, config.id);
    }

    @Menu(ActionType.TAILOR_PIC_WH_1_1, 'onClick')
    @Menu(ActionType.TAILOR_PIC_WH_2_3, 'onClick')
    @Menu(ActionType.TAILOR_PIC_WH_3_4, 'onClick')
    @Menu(ActionType.TAILOR_PIC_WH_3_5, 'onClick')
    @Menu(ActionType.TAILOR_PIC_WH_4_5, 'onClick')
    @Menu(ActionType.TAILOR_PIC_WH_3_2, 'onClick')
    @Menu(ActionType.TAILOR_PIC_WH_4_3, 'onClick')
    @Menu(ActionType.TAILOR_PIC_WH_5_3, 'onClick')
    @Menu(ActionType.TAILOR_PIC_WH_5_4, 'onClick')
    @Menu(ActionType.TAILOR_PIC_WH_16_9, 'onClick')
    @Menu(ActionType.TAILOR_PIC_WH_16_10, 'onClick')
    @Menu(MenuKey.TAILOR_PIC_WH_1_1, 'onClick')
    @Menu(MenuKey.TAILOR_PIC_WH_2_3, 'onClick')
    @Menu(MenuKey.TAILOR_PIC_WH_3_4, 'onClick')
    @Menu(MenuKey.TAILOR_PIC_WH_3_5, 'onClick')
    @Menu(MenuKey.TAILOR_PIC_WH_4_5, 'onClick')
    @Menu(MenuKey.TAILOR_PIC_WH_3_2, 'onClick')
    @Menu(MenuKey.TAILOR_PIC_WH_4_3, 'onClick')
    @Menu(MenuKey.TAILOR_PIC_WH_5_3, 'onClick')
    @Menu(MenuKey.TAILOR_PIC_WH_5_4, 'onClick')
    @Menu(MenuKey.TAILOR_PIC_WH_16_9, 'onClick')
    @Menu(MenuKey.TAILOR_PIC_WH_16_10, 'onClick')
    public onClick(@ActionPointInfo() info:  IActionPointInfo) {
        let id = info.name;
        if (info.name.indexOf(PREFIX) !== -1) {
            id = info.name.replace(PREFIX, '');
        }
        this.feature.callbackByActionType(id);
    }
}
